import { render, staticRenderFns } from "./NestedComputedTextContent.vue?vue&type=template&id=4c180e76"
import script from "./NestedComputedTextContent.vue?vue&type=script&lang=js"
export * from "./NestedComputedTextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports